import React, { Component,  useState, useEffect  } from 'react';
import './EstruturaTO2.css';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import ventos from '../../assets/videos/ventos.mp4';
import interativo2Ativo1 from '../../assets/svgs/interativoAtivo 1.svg';        
import Dt2 from "../../assets/fundos/Dt2.jpg";
import controleremoto from '../../assets/svgs/Controle-01.svg';      
import $, { when } from "jquery";
import { debounce, throttle } from 'lodash';
import seta from '../../assets/svgs/more-white.svg';   

class EstruturaTO2 extends Component {
    componentDidMount() {

      

        if(window.matchMedia("(max-width: 600px)").matches){
    
        }
        else{
          if($( ".magazinenova" ).mousemove=true){
            $( ".magazinenova" ).mousemove(function( event ) {

              $("#TO2desapa").fadeIn();
        
              
            });
          }
          else{
            $("#TO2desapa").fadeOut();
    
          }
    
        }
    
    
         $("#TO2dimensao").click(function()
        
        {

          $(".sidebar-wrapper").removeClass("show-sidebar", 500);
          $(".menuuu").addClass("todonone");
          $(".ffechar").addClass("todonone", 500);

          $("#TO2video").prop('muted', false);
          $("#TO2dimensao").addClass("todonone");
          $("#TO2dimensao2").removeClass("todonone");
          $("#TO2desapa2").addClass("todonone");
          $("#TO2video").addClass("pulo");

          $("#TO7dimensao").removeClass("todonone");
          $("#TO7desapa2").removeClass("todonone");
          $("#TO7obra1").removeClass("pulo");
          $("#TO7obra1").removeClass("pulo");
          $("#TO7video").removeClass("pulo");
          $("#TO7local1").removeClass("pulo");
          $("#TO7video").prop('muted', true);

          $("#TO6dimensao").removeClass("todonone");
          $("#TO6desapa2").removeClass("todonone");
          $("#TO6obra1").removeClass("pulo");
          $("#TO6obra1").removeClass("pulo");
          $("#TO6video").removeClass("pulo");
          $("#TO6local1").removeClass("pulo");
          $("#TO6video").prop('muted', true);

          $("#TO5dimensao").removeClass("todonone");
          $("#TO5desapa2").removeClass("todonone");
          $("#TO5obra1").removeClass("pulo");
          $("#TO5obra1").removeClass("pulo");
          $("#TO5video").removeClass("pulo");
          $("#TO5local1").removeClass("pulo");
          $("#TO5video").prop('muted', true);

          $("#TO4dimensao").removeClass("todonone");
          $("#TO4desapa2").removeClass("todonone");
          $("#TO4obra1").removeClass("pulo");
          $("#TO4obra1").removeClass("pulo");
          $("#TO4video").removeClass("pulo");
          $("#TO4local1").removeClass("pulo");
          $("#TO4video").prop('muted', true);

          $("#TO3dimensao").removeClass("todonone");
          $("#TO3desapa2").removeClass("todonone");
          $("#TO3obra1").removeClass("pulo");
          $("#TO3obra1").removeClass("pulo");
          $("#TO3video").removeClass("pulo");
          $("#TO3local1").removeClass("pulo");
          $("#TO3video").prop('muted', true);

          $("#TO8dimensao").removeClass("todonone");
          $("#TO8desapa2").removeClass("todonone");
          $("#TO8obra1").removeClass("pulo");
          $("#TO8obra1").removeClass("pulo");
          $("#TO8video").removeClass("pulo");
          $("#TO8local1").removeClass("pulo");
          $("#TO8video").prop('muted', true);

          $("#dimensao").removeClass("todonone");
          $("#desapa2").removeClass("todonone");
          $("#obra1").removeClass("pulo");
          $("#obra1").removeClass("pulo");
          $("#video").removeClass("pulo");
          $("#local1").removeClass("pulo");
          $("#video").prop('muted', true);

      
    
        }
        );
        $("#TO2dimensao2").click(function()
        
        {
          $(".menuuu").removeClass("todonone");
    
          $("#TO2video").prop('muted', true);
          $("#TO2dimensao2").addClass("todonone");
          $("#TO2dimensao").removeClass("todonone");
          $("#TO2desapa2").removeClass("todonone");
          $("#TO2obra1").removeClass("pulo");
          $("#TO2obra1").removeClass("pulo");
          $("#TO2video").removeClass("pulo");
          $("#TO2local1").removeClass("pulo");
        }
        );
    
    
        $("#TO2magazinenova").click(function(){
          $("#TO2desapa").delay('slow').fadeIn();
            
        
    
          setTimeout(
            function() 
            {
    
              
              var desaparecendo = 'todonone';

              $("#TO2desapa").fadeOut();
            }, 30000);
    
        });
    
        (function () {
    
          $("#TO2botomenu").click(function () {
            $( this ).slideUp().fadeOut(10000);
            $("#TO2hold1 ").addClass("cc");
            $("#TO2botoobras ").addClass("cc");
            $("#TO2hold3 ").addClass("cc");
            $("#TO2hold4 ").addClass("cc");
            $("#TO2hold5 ").addClass("cc");
            $("#TO2hold1 ").removeClass("transiopaca");
            $("#TO2botoobras ").removeClass("transiopaca");
            $("#TO2hold3 ").removeClass("transiopaca");
            $("#TO2hold4 ").removeClass("transiopaca");
            $("#TO2hold5 ").removeClass("transiopaca");
            setTimeout(function(){
              setTimeout(function(){
                $("#TO2hold5 ").addClass("transiopaca");
                setTimeout(function(){
                  $("#TO2hold4 ").addClass("transiopaca");
                  setTimeout(function(){
                    $("#TO2hold3 ").addClass("transiopaca");
                    setTimeout(function(){
                      $("#TO2botoobras ").addClass("transiopaca");
                      $("#TO2hold1 ").addClass("transiopaca");
                      setTimeout(function(){
                        $("#TO2hold1 ").removeClass("cc");
                        $("#TO2botoobras ").removeClass("cc");
                        $("#TO2hold3 ").removeClass("cc");
                        $("#TO2hold4 ").removeClass("cc");
                        $("#TO2hold5 ").removeClass("cc");
                        $("#TO2botomenu").slideDown();
                      },1000);
                    },1000);
    
    
                  },1000);
    
    
                },1000);
    
              },1000);
    
    
    
    
    
    
    
              }, 3000);

          });
    
          var qua = $('.resposta');
          var $target = $('.gatilhoObra'),
            animationClass = 'respostaGatilho',
            animationClass2 = 'respostaGatilho2',
            offset = $(window).height() * 1 / 10;
    
    
    
          function animeScroll() {
            $("#TO2desapa").fadeOut();
            
        
    
            setTimeout(
              function() 
              {
                var desaparecendo = 'todonone';

                $("#TO2desapa").fadeIn();
              }, 2000);
    
    
            var documentTop = $(document).scrollTop();
    
            $target.each(function (index) {
    
              var itemTop = $(this).offset().top;
    
              if (documentTop > itemTop - offset) {
                $("#TO2botoobras").addClass(animationClass2);
                
              }
              else{
                $("#TO2boto" + index).removeClass(animationClass);
                  
              }
    
              if (documentTop > itemTop - offset) {
                $("#TO2boto" + index).addClass(animationClass);
                
                if (documentTop > itemTop * 2 - offset * 2) {
                  $("#TO2boto" + index).removeClass(animationClass);
                  
                }
                if (documentTop > itemTop){
                  $("#TO2boto" + index).removeClass(animationClass);
                  
                }
              }
            }
    
            
    
            );
          }
    
         
    
          $(document).scroll(debounce(function () {
            animeScroll();
          }, 200));
        })();
    
    
        $('.bolinhas a[href^="#TO2"]').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href'),
            targetOffset = $(id).offset().top;
    
          $('html, body').animate({
            scrollTop: targetOffset - 0
          }, 500);
        });
    
        $('.grandeMenu a[href^="#TO2"]').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href'),
            targetOffset = $(id).offset().top;
    
          $('html, body').animate({
            scrollTop: targetOffset - 0
          }, 500);
        });
      }
    
   
    render() {

        
        return (
            <div id="TO2obra1" className="displayTO2 gatilhoObra"> {this.props.children}
                <div id="TO2local1"className="videolocalTO2" style={{backgroundImage: 'url(' + {Dt2} +')'}}>
                <div class="sidebar-wrapper">
                        <div class="sidebar">
                            <h3> 2015 - 2016   </h3>
                            <h2 class="sidebar-titulo"> VENTOS UIVANTES </h2>
                            <p class="descricao">A obra inspira-se no fenômeno do vento em sua dimensão  de força da natureza em Natal, RN, Brasil.  Trata-se de uma instalação que capta o movimento do vento  e outros índices naturais vinculados a ele,  mesclando-o ao final com a captação do “sopro” humano oriundo do publico que transformam-se em respostas musicais e interativas luminosas e sonoras. A documentação presente é apenas da segunda fase da obra. </p>
                            <a className="botaops repon"  href="https://editor.p5js.org/10Dimensoes/present/ItQT688p9">obra interativa</a>
                        </div>
                        <div class="menuuu" id="menuuu"><i class="fa fa-bars fa-2x">
                        <img  className="ring button" src={seta} alt=""/>
                        
                            
                            
                            
                            
                            </i></div>
                    </div>
                    <div className="ffechar todonone">
                       <i> FECHAR </i>
                    </div>
                    <div className="tampavideoTO2">
                    </div>
                    <div className="videoTO2" >
                        <video controlsList = "nofullscreen nodownload noremoteplayback" poster="a" id="TO2video" playsInline autoPlay muted loop>
                            <source src={ventos} type="video/mp4">
                            </source>
                        </video>
                    </div>
                    <div className="sobrepo1TO2"></div>
                    <div className="sobrepo2TO2"></div>
                    <div className="sobrepo3TO2"></div>
                </div>
                <div id="TO2desapa" className="magazineTO2">
                    
                </div>
                <div className="magazinenova" id="TO2magazinenova">
                    <div id="TO2dimensao"className="controleremoto">
                        <img src={controleremoto} alt=""/>
                    </div>
                    <div id="TO2dimensao2"className="controleremoto2 todonone">
                    <img src={controleremoto} alt=""/>
                        
                </div>
                </div>
            </div>
        );
    }
}
 
export default EstruturaTO2  ;